var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.869 10.914q7.592-3.309 10.125-4.361c4.822-2.006 5.823-2.354 6.477-2.366.143-.002.464.033.672.202a.73.73 0 0 1 .247.47c.024.135.052.443.03.684-.262 2.745-1.392 9.407-1.968 12.482-.243 1.301-.722 1.738-1.186 1.78-1.008.093-1.774-.666-2.75-1.306-1.529-1.002-2.392-1.625-3.875-2.603-1.714-1.13-.603-1.75.374-2.765.255-.266 4.698-4.306 4.784-4.673.01-.046.02-.217-.081-.307s-.251-.06-.36-.035q-.23.053-7.323 4.84-1.039.716-1.883.696c-.62-.013-1.812-.35-2.699-.638-1.087-.354-1.951-.54-1.876-1.14q.06-.47 1.292-.96"
  })));
};
export default SvgTelegram;